<span *ngIf="rowOnEdit" class="row-edited">{{user_name}}</span>
<!--<button mat-stroked-button>Basic</button>-->
<div *ngIf="handleError === false">
  <button [disabled]="disabled || disabledAll" mat-stroked-button color="primary" (click)="yes()">Yes</button>&nbsp;
  <button [disabled]="disabled || disabledAll" mat-stroked-button color="warn" (click)="no()">No</button>
</div>
<div *ngIf="handleError" class="confirm-handle-error">Handle/SKU Error</div>
<!--<button mat-mini-fab color="primary">-->
<!--  <mat-icon>done</mat-icon>-->
<!--</button>-->
<!--<button mat-mini-fab color="accent">-->
<!--  <mat-icon>close</mat-icon>-->
<!--</button>-->
